module.exports = __webpack_public_path__ + "static/media/welcome_image_netwell.8cb7d93a.png";